var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card } from '@tremor/react';
export function Widget(_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, className = _a.className, cardClassName = _a.cardClassName, children = _a.children, titleAction = _a.titleAction, titleActionClassName = _a.titleActionClassName, titleClassName = _a.titleClassName, titleContainerClassName = _a.titleContainerClassName;
    return (_jsx("div", __assign({ className: className }, { children: _jsxs(Card, __assign({ className: cardClassName }, { children: [title && (_jsxs("div", __assign({ className: "flex items-center justify-between ".concat(titleContainerClassName || '') }, { children: [_jsx("h3", __assign({ className: "mb-3 text-xl font-semibold text-tremor-content-strong dark:text-dark-tremor-content-strong ".concat(titleClassName || '') }, { children: title })), titleAction && (_jsx("div", __assign({ className: titleActionClassName }, { children: titleAction })))] }))), _jsx("div", { children: children })] })) })));
}
export default Widget;
